import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@material-ui/core';
import ButtonsForm from 'ui/form/ButtonsForm';
import Fields from 'ui/form/FieldsForm';
import DialogButtons from 'ui/dialog/Buttons';
import { AuthService } from '../../../../../auth/Service';

export const PasswordDialog = ({ onSubmit, onCancel, open, currentUser }) => {
    const [value, setValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const confirm_code = await AuthService.ConfirmPassword(
                currentUser.username,
                value
            );
            onSubmit(confirm_code);
        } catch {
            setError(true);
            setLoading(false);
        }
    };
    return (
        <Dialog open={open} maxWidth="xs" fullWidth>
            <DialogTitle>Confirm password to continue</DialogTitle>
            <DialogContent>
                <Fields.Text
                    label="Password"
                    type="password"
                    value={value}
                    onChange={val => setValue(val)}
                    error={error ? 'Invalid password' : null}
                    autoFocus
                    onEnterPress={handleSubmit}
                />
            </DialogContent>
            <DialogActions>
                <DialogButtons>
                    <ButtonsForm.BackButton label="Cancel" onClick={onCancel} />
                    <ButtonsForm.NextButton
                        label="NEXT"
                        onClick={handleSubmit}
                        loading={loading}
                        disabled={!value}
                    />
                </DialogButtons>
            </DialogActions>
        </Dialog>
    );
};
